define('viewmodels/pages/iddqd',[],function () {

    return function IddqdViewModel (
        navigation,
        debugModeEnabled,
        showDisabledGames,
        gameLauncherStrategyOverride,
        adventureOverride,
        session,
        settings,
        i18n,
        tournamentsOverride
    ) {

        var player = session.getAssociatedPlayer;

        this.debugModeEnabled = debugModeEnabled.orElse(false);

        this.showDisabledGames = showDisabledGames.orElse(false);

        this.gamificationOverrides = {
            gameLauncherOptions: [
                'DEFAULT',
                'GAME_OVERLAY'
            ],
            gameLauncherStrategyOverride: gameLauncherStrategyOverride,

            adventureOptions: [
                'VC_PLAIN',
                'VC_WITH_CHESTS_MILESTONE',
                'VC_WITH_CHESTS_RANDOM'
            ],
            adventureOverride: adventureOverride
        };

        // market change
        this.selectMarket = function (market) {

            if (session.loggedIn()) {
                player().market(market);
            } else {
                settings.selectMarket(market);
            }
        };

        this.availableMarkets = i18n.markets;

        this.selectedMarket = settings.selectedMarket;

        this.tournamentsOverride = tournamentsOverride;

        this.getView = function () {

            if (navigation.getRouter().activeInstruction().config.id === navigation.ROUTES.IDDQD_LIGHT) {
                return 'views/pages/iddqdLight';
            }

        };

    };

});

